import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

@Injectable({ providedIn: 'root' })
export class MobileChromeService {
  async applyThemeChrome() {
    if (!Capacitor.isNativePlatform()) return;

    try {
      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setBackgroundColor({ color: '#03932a' });
      await StatusBar.setStyle({ style: Style.Light });
    } catch {
      // Native chrome styling should not block app startup.
    }
  }
}
